import { Language } from './LanguageContext';

// 翻译资源接口
export interface TranslationResources {
  [key: string]: {
    [key in Language]: string;
  };
}

// 翻译资源定义
export const translations: TranslationResources = {
  // Workbench页面翻译
  'AI Translation Process': {
    'en': 'AI Translation Process',
    'zh-CN': 'AI翻译中心',
    'zh-TW': 'AI翻譯中心'
  },
  'Log out': {
    'en': 'Log out',
    'zh-CN': '退出登录',
    'zh-TW': '登出'
  },
  'Signing you in...': {
    'en': 'Signing you in...',
    'zh-CN': '正在登录...',
    'zh-TW': '正在登入...'
  },
  'Signing you out...': {
    'en': 'Signing you out...',
    'zh-CN': '正在退出...',
    'zh-TW': '正在登出...'
  },
  'Loading...': {
    'en': 'Loading...',
    'zh-CN': '加载中...',
    'zh-TW': '載入中...'
  },
  'Oops...': {
    'en': 'Oops...',
    'zh-CN': '哎呀...',
    'zh-TW': '哎呀...'
  },
  
  // 通用翻译
  'Save': {
    'en': 'Save',
    'zh-CN': '保存',
    'zh-TW': '儲存'
  },
  'Cancel': {
    'en': 'Cancel',
    'zh-CN': '取消',
    'zh-TW': '取消'
  },
  'Submit': {
    'en': 'Submit',
    'zh-CN': '提交',
    'zh-TW': '提交'
  },
  'Delete': {
    'en': 'Delete',
    'zh-CN': '删除',
    'zh-TW': '刪除'
  },
  'Edit': {
    'en': 'Edit',
    'zh-CN': '编辑',
    'zh-TW': '編輯'
  },
  'Create': {
    'en': 'Create',
    'zh-CN': '创建',
    'zh-TW': '創建'
  },
  'Search': {
    'en': 'Search',
    'zh-CN': '搜索',
    'zh-TW': '搜尋'
  },
  'Filter': {
    'en': 'Filter',
    'zh-CN': '筛选',
    'zh-TW': '篩選'
  },
  'Settings': {
    'en': 'Settings',
    'zh-CN': '设置',
    'zh-TW': '設定'
  },
  'Profile': {
    'en': 'Profile',
    'zh-CN': '个人资料',
    'zh-TW': '個人資料'
  },
  'Help': {
    'en': 'Help',
    'zh-CN': '帮助',
    'zh-TW': '幫助'
  },
  'About': {
    'en': 'About',
    'zh-CN': '关于',
    'zh-TW': '關於'
  },
  'My Process': {
    'en': 'My Process',
    'zh-CN': '翻译流程',
    'zh-TW': '我的翻譯流程'
  },
  'Upload file':{
    'en': 'Upload file',
    'zh-CN': '上传文件',
    'zh-TW': '上傳文件'
  },
  'Preview translation file':{
    'en': 'Preview translation file',
    'zh-CN': '预览翻译文件',
    'zh-TW': '預覽翻譯文件'
  },
  'Auto-detect':{
    'en': 'Auto-detect',
    'zh-CN': '自动检测',
    'zh-TW': '自動檢測'
  },
  'English (United States)':{
    'en': 'English (United States)',
    'zh-CN': '英语（美国）',
    'zh-TW': '英语（美國）'
  },
  'Full Translation for prefix':{
    'en': 'Full Translation for',
    'zh-CN': '仅需 ',
    'zh-TW': '仅需 '
  },
  'Full Translation for suffix':{
    'en': ' ',
    'zh-CN': ' 获取完整翻译',
    'zh-TW': ' 获取完整翻译'
  },
  'Upgrade to Translation Pro':{
    'en': 'Upgrade to Translation Pro',
    'zh-CN': '升级到翻译专业版',
    'zh-TW': '升級到翻譯專業版'
  },
  'Upload and translate file':{
    'en': 'Upload and translate file',
    'zh-CN': '上传并翻译文件',
    'zh-TW': '上傳並翻譯文件'
  },
  'Drop your file to start translating.':{
    'en': 'Drop your file to start translating.',
    'zh-CN': '将文件拖放到此处开始翻译。',
    'zh-TW': '將文件拖放到此处開始翻譯。'
  },
  'Important:':{
    'en': 'Important:',
    'zh-CN': '重要提示：',
    'zh-TW': '重要提示：'
  },
  'We support ':{
    'en': 'We support ',
    'zh-CN': '我们仅支持 ',
    'zh-TW': '我們僅支持 '
  },
  'PDF and image files only':{
    'en': 'PDF and image files only',
    'zh-CN': 'PDF 和图片文件',
    'zh-TW': 'PDF 和圖片文件'
  },
  ' (DOCX/DOC not accepted — please convert to PDF).':{
    'en': ' (DOCX/DOC not accepted — please convert to PDF).',
    'zh-CN': '（不接受 DOCX/DOC — 请转换为 PDF）。',
    'zh-TW': '（不接受 DOCX/DOC — 請轉換為 PDF）。'
  },
  'Only the ':{
    'en': 'Only the ',
    'zh-CN': '仅翻译前 ',
    'zh-TW': '僅翻譯前 '
  },
  'first 15 pages':{
    'en': 'first 15 pages',
    'zh-CN': '15 页',
    'zh-TW': '15 頁'
  },
  ' will be translated.':{
    'en': ' will be translated.',
    'zh-CN': '。',
    'zh-TW': '。'
  },
  'For files over ':{
    'en': 'For files over ',
    'zh-CN': '对于超过 ',
    'zh-TW': '對於超過 '
  },
  '10 MB':{
    'en': '10 MB',
    'zh-CN': '10 MB',
    'zh-TW': '10 MB'
  },
  ' or longer than ':{
    'en': ' or longer than ',
    'zh-CN': ' 或超过 ',
    'zh-TW': ' 或超過 '
  },
  '15 pages':{
    'en': '15 pages',
    'zh-CN': '15 页',
    'zh-TW': '15 頁'
  },
  ', please ':{
    'en': ', please ',
    'zh-CN': ' 的文件，请',
    'zh-TW': ' 的文件，請'
  },
  'contact us':{
    'en': 'contact us',
    'zh-CN': '联系我们',
    'zh-TW': '聯絡我們'
  },
  ' for extended support.':{
    'en': ' for extended support.',
    'zh-CN': '获取扩展支持。',
    'zh-TW': '獲取擴展支持。'
  },
  'English':{
    'en': 'English',
    'zh-CN': '英语',
    'zh-TW': '英语'
  },
  'Recent Translation History':{
    'en': 'Recent Translation History',
    'zh-CN': '最近翻译历史',
    'zh-TW': '最近翻譯歷史'
  },
  'New Translation':{
    'en': 'New Translation',
    'zh-CN': '新建翻译',
    'zh-TW': '新建翻译'
  },
  'Translation Process':{
    'en': 'Translation Process',
    'zh-CN': '翻译任务',
    'zh-TW': '翻譯流程'
  },
  'Translation status':{
    'en': 'Translation status',
    'zh-CN': '翻译状态',
    'zh-TW': '翻譯狀態'
  },
  'Date created':{
    'en': 'Date created',
    'zh-CN': '创建日期',
    'zh-TW': '創建日期'
  },
  'Working with something bigger?':{
    'en': 'Working with something bigger?',
    'zh-CN': '正在处理更大的项目？',
    'zh-TW': '正在處理更大的項目？'
  },
  'Contact us to get started.':{
    'en': 'Contact us to get started.',
    'zh-CN': '联系我们开始使用。',
    'zh-TW': '聯絡我們開始使用。'
  },
  "Click to upload":{
    'en': 'Click to upload',
    'zh-CN': '点击上传',
    'zh-TW': '點擊上傳'
  },
  "or drag and drop":{
    'en': 'or drag and drop',
    'zh-CN': '或拖动并释放',
    'zh-TW': '或拖動並釋放'
  },
  "PDF, DOC, DOCX or PNG (max. 10mb)":{
    'en': 'PDF, DOC, DOCX or PNG (max. 10mb)',
    'zh-CN': 'PDF, DOC, DOCX 或 PNG 文件（最大 10MB）',
    'zh-TW': 'PDF, DOC, DOCX 或 PNG 文件（最大 10MB）'
  },
  "We have translate the first 3 pages as a preview. To access full translated file, please proceed to full translation.":{
    'en': 'We have translate the first 3 pages as a preview. To access full translated file, please proceed to full translation.',
    'zh-CN': '已为您自动检测语言并翻译前 3 页内容，供您预览效果。想查看完整文件？点击“开始完整翻译”即可！',
    'zh-TW': '已为您自动检测语言并翻译前 3 页内容，供您预览效果。想查看完整文件？点击“开始完整翻译”即可！'
  },
  "COMPLETED":{
    'en': 'Completed',
    'zh-CN': '已完成',
    'zh-TW': '已完成'
  },
  "Ready for Preview":{
    'en': 'Ready for Preview',
    'zh-CN': '可预览',
    'zh-TW': '準備預覽'
  },
  "Get professional translation services with guaranteed quality and fast delivery":{
    'en': 'Get professional translation services with guaranteed quality and fast delivery',
    'zh-CN': '享受由专业译员提供的高质量、极速翻译服务',
    'zh-TW': '享受由专业译员提供的高质量、极速翻译服务'
  },
  "Professional Team":{
    'en': 'Professional Team',
    'zh-CN': '专业译员团队',
    'zh-TW': '專業譯員團隊'
  },
  "Fast Delivery":{
    'en': 'Fast Delivery',
    'zh-CN': '极速交付',
    'zh-TW': '极速交付'
  },
  "Format Retention":{
    'en': 'Format Retention',
    'zh-CN': '格式保留',
    'zh-TW': '格式保留'
  },
  "Certified translators with years of experience":{
    'en': 'Certified translators with years of experience',
    'zh-CN': '多年经验的认证译员',
    'zh-TW': '多年经验的认证译员'
  },
  "24-hour turnaround time guaranteed":{
    'en': '24-hour turnaround time guaranteed',
    'zh-CN': '24小時翻譯完成',
    'zh-TW': '24小時翻譯完成'
  },
  "total: ":{
    'en': 'total: ',
    'zh-CN': '共 ',
    'zh-TW': '共 '
  },
  "total: suffix":{
    'en': ' ',
    'zh-CN': ' 条',
    'zh-TW': ' 条'
  },
  "Download Format":{
    'en': 'Download Format',
    'zh-CN': '下载格式选择',
    'zh-TW': '下載格式选择'
  },
  "Please select the format you want to download":{
    'en': 'Please select the format you want to download',
    'zh-CN': '请选择您要下载的格式',
    'zh-TW': '請選擇您要下載的格式'
  },

  // Landing Page Translations
  'landing.navbar.company': {
    'en': 'Company',
    'zh-CN': '公司官网',
    'zh-TW': '公司官網'
  },
  'landing.navbar.contactSales': {
    'en': 'Contact Sales',
    'zh-CN': '联系销售',
    'zh-TW': '聯絡銷售'
  },
  'landing.navbar.tryTranslator': {
    'en': 'Try Translator',
    'zh-CN': '试用翻译器',
    'zh-TW': '試用翻譯器'
  },
  'landing.hero.headlineMain': {
    'en': 'Advanced PDF Translation',
    'zh-CN': '高级 PDF 文档翻译',
    'zh-TW': '高級 PDF 文檔翻譯'
  },
  'landing.hero.headlineSub': {
    'en': 'Preserving Every Detail',
    'zh-CN': '完美保留每一个细节',
    'zh-TW': '完美保留每一個細節'
  },
  'landing.hero.description': {
    'en': 'Experience seamless document translation. Our AI accurately translates your PDFs while flawlessly preserving the original layout, formatting, and tables—delivering professional-grade results in seconds.',
    'zh-CN': '体验无缝的文档翻译。我们的人工智能在精准翻译内容的同时，完美保留原始布局、格式和表格——在几秒钟内交付专业级的结果。',
    'zh-TW': '體驗無縫的文檔翻譯。我們的人工智能在精準翻譯內容的同時，完美保留原始佈局、格式和表格——在幾秒鐘內交付專業級的結果。'
  },
  'landing.hero.cta': {
    'en': 'Translate PDF Now',
    'zh-CN': '立即翻译 PDF',
    'zh-TW': '立即翻譯 PDF'
  },
  'landing.features.f1.title': {
    'en': 'Perfect Format Retention',
    'zh-CN': '完美保留格式',
    'zh-TW': '完美保留格式'
  },
  'landing.features.f1.desc': {
    'en': 'We specialize in maintaining the integrity of your documents. Our AI translates text while preserving alignment, fonts, styling, and spacing exactly as they appear in the original PDF.',
    'zh-CN': '我们专注于维护文档的完整性。AI 在翻译文本的同时，会严格保留原始 PDF 中的对齐方式、字体、样式和间距，确保版面与原文一致。',
    'zh-TW': '我們專注於維護文檔的完整性。AI 在翻譯文本的同時，會嚴格保留原始 PDF 中的對齊方式、字體、樣式和間距，確保版面與原文一致。'
  },
  'landing.features.f2.title': {
    'en': 'Unstructured Data Handling',
    'zh-CN': '处理非结构化数据',
    'zh-TW': '處理非結構化數據'
  },
  'landing.features.f2.desc': {
    'en': 'Our engine excels at complex PDFs. Whether it\'s a scanned document, embedded images, or intricate tables, our advanced OCR and layout analysis ensures every piece of data is captured.',
    'zh-CN': '我们的引擎擅长处理复杂的 PDF。无论是扫描件、嵌入式图片还是复杂的表格，我们的先进 OCR 和版面分析技术都能确保捕获每一条数据。',
    'zh-TW': '我們的引擎擅長處理複雜的 PDF。無論是掃描件、嵌入式圖片還是複雜的表格，我們的先進 OCR 和版面分析技術都能確保捕獲每一條數據。'
  },
  'landing.features.f3.title': {
    'en': 'Full Document Processing',
    'zh-CN': '全文档一键处理',
    'zh-TW': '全文檔一鍵處理'
  },
  'landing.features.f3.desc': {
    'en': 'Efficiency is key. Drop in your entire PDF file—no matter how many pages—and let us handle the rest. No splitting files, no page-by-page uploads. Get a complete translated document in one go.',
    'zh-CN': '效率至上。直接上传整个 PDF 文件——无论有多少页——剩下的交给我们。无需拆分文件，无需逐页上传。一次性获取完整的翻译文档。',
    'zh-TW': '效率至上。直接上傳整個 PDF 文件——無論有多少頁——剩下的交給我們。無需拆分文件，無需逐頁上傳。一次性獲取完整的翻譯文檔。'
  },
  'landing.features.f4.title': {
    'en': 'Export to PDF & PPTX',
    'zh-CN': '导出 PDF 和 PPTX',
    'zh-TW': '導出 PDF 和 PPTX'
  },
  'landing.features.f4.desc': {
    'en': 'Flexibility for your workflow. Once translated, download your document as a print-ready PDF or an editable PowerPoint (PPTX) file to continue working on your presentation seamlessly.',
    'zh-CN': '灵活适配您的工作流。翻译完成后，您可以下载可直接打印的 PDF 或可编辑的 PowerPoint (PPTX) 文件，以便无缝继续您的演示工作。',
    'zh-TW': '靈活適配您的工作流。翻譯完成後，您可以下載可直接打印的 PDF 或可編輯的 PowerPoint (PPTX) 文件，以便無縫繼續您的演示工作。'
  },
  'landing.features.visuals.original': {
    'en': 'EN - ORIGINAL',
    'zh-CN': 'EN - 原文',
    'zh-TW': 'EN - 原文'
  },
  'landing.features.visuals.translated': {
    'en': 'CN - TRANSLATED',
    'zh-CN': 'CN - 译文',
    'zh-TW': 'CN - 譯文'
  },
  'landing.features.visuals.imgDetected': {
    'en': 'Image Detected',
    'zh-CN': '检测到图片',
    'zh-TW': '檢測到圖片'
  },
  'landing.features.visuals.tableDetected': {
    'en': 'Table Detected',
    'zh-CN': '检测到表格',
    'zh-TW': '檢測到表格'
  },
  'landing.features.visuals.processed': {
    'en': 'Processed',
    'zh-CN': '处理完成',
    'zh-TW': '處理完成'
  },
  'landing.features.visuals.pages': {
    'en': '128 Pages',
    'zh-CN': '128 页',
    'zh-TW': '128 頁'
  },
  'landing.features.visuals.printReady': {
    'en': 'Print Ready',
    'zh-CN': '可直接打印',
    'zh-TW': '可直接打印'
  },
  'landing.features.visuals.fullyEditable': {
    'en': 'Fully Editable',
    'zh-CN': '完全可编辑',
    'zh-TW': '完全可編輯'
  },
  'landing.contact.headline': {
    'en': 'Professional Translation Services',
    'zh-CN': '专业级翻译服务',
    'zh-TW': '專業級翻譯服務'
  },
  'landing.contact.description': {
    'en': 'We provide comprehensive translation services for law firms, global enterprises, and individuals. Experience AI-powered speed combined with expert human oversight to deliver results you can trust.',
    'zh-CN': '我们为律师事务所、跨国企业和个人用户提供专业的翻译服务。体验 AI 驱动的速度与专家人工校验的完美结合，交付值得信赖的结果。',
    'zh-TW': '我們為律師事務所、跨國企業和個人用戶提供專業的翻譯服務。體驗 AI 驅動的速度與專家人工校驗的完美結合，交付值得信賴的結果。'
  },
  'landing.contact.features.speed.title': {
    'en': 'Lightning Fast Delivery',
    'zh-CN': '闪电般的交付速度',
    'zh-TW': '閃電般的交付速度'
  },
  'landing.contact.features.speed.desc': {
    'en': 'Optimized engine handles high-volume requests instantly.',
    'zh-CN': '优化引擎即时处理大批量请求。',
    'zh-TW': '優化引擎即時處理大批量請求。'
  },
  'landing.contact.features.verify.title': {
    'en': 'Expert Verification',
    'zh-CN': '专家人工校验',
    'zh-TW': '專家人工校驗'
  },
  'landing.contact.features.verify.desc': {
    'en': 'Optional human-in-the-loop review for absolute certainty.',
    'zh-CN': '可选的人机协同（Human-in-the-loop）审核，确保绝对准确。',
    'zh-TW': '可選的人機協同（Human-in-the-loop）審核，確保絕對準確。'
  },
  'landing.contact.features.accuracy.title': {
    'en': 'Unmatched Accuracy',
    'zh-CN': '无与伦比的准确度',
    'zh-TW': '無與倫比的準確度'
  },
  'landing.contact.features.accuracy.desc': {
    'en': 'Precise terminology handling tailored to your domain.',
    'zh-CN': '针对您特定领域的术语要求进行精准处理。',
    'zh-TW': '針對您特定領域的術語要求進行精準處理。'
  },
  'landing.contact.features.industry.title': {
    'en': 'Multi-Industry Support',
    'zh-CN': '多行业支持',
    'zh-TW': '多行業支持'
  },
  'landing.contact.features.industry.desc': {
    'en': 'Specialized for Law, Finance, Business, and Academia.',
    'zh-CN': '专为法律、金融、商业和学术界打造的解决方案。',
    'zh-TW': '專為法律、金融、商業和學術界打造的解決方案。'
  },
  'landing.contact.quote': {
    'en': 'The combination of speed and accuracy is impressive. The format retention saves us hours of work on every project.',
    'zh-CN': '速度和准确性的结合令人印象深刻。格式保留功能为我们在每个项目上节省了数小时的工作时间。',
    'zh-TW': '速度和準確性的結合令人印象深刻。格式保留功能為我們在每個項目上節省了數小時的工作時間。'
  },
  'landing.contact.teamName': {
    'en': 'RoundBlock Team',
    'zh-CN': 'RoundBlock 团队',
    'zh-TW': 'RoundBlock 團隊'
  },
  'landing.contact.teamRole': {
    'en': 'AI & Language Experts',
    'zh-CN': 'AI 与语言专家',
    'zh-TW': 'AI 與語言專家'
  },
  'landing.contact.formHeader': {
    'en': 'CONTACT',
    'zh-CN': '联系我们',
    'zh-TW': '聯絡我們'
  },
  'landing.contact.formSub': {
    'en': 'Ready to start your translation project? Reach out to our team.',
    'zh-CN': '准备好开始您的翻译项目了吗？请联系我们的团队。',
    'zh-TW': '準備好開始您的翻譯項目了嗎？請聯絡我們的團隊。'
  },
  'landing.contact.headquarters': {
    'en': 'Headquarters',
    'zh-CN': '总部地址',
    'zh-TW': '總部地址'
  },
  'landing.contact.emailUs': {
    'en': 'Email Us',
    'zh-CN': '发送邮件',
    'zh-TW': '發送郵件'
  },
  'landing.contact.tabService': {
    'en': 'Translation Services',
    'zh-CN': '翻译服务咨询',
    'zh-TW': '翻譯服務諮詢'
  },
  'landing.contact.tabSupport': {
    'en': 'Product Support',
    'zh-CN': '产品技术支持',
    'zh-TW': '產品技術支持'
  },
  'landing.contact.labels.name': {
    'en': 'Name *',
    'zh-CN': '姓名 *',
    'zh-TW': '姓名 *'
  },
  'landing.contact.labels.email': {
    'en': 'Email *',
    'zh-CN': '电子邮箱 *',
    'zh-TW': '電子郵箱 *'
  },
  'landing.contact.labels.company': {
    'en': 'Company Name',
    'zh-CN': '公司名称',
    'zh-TW': '公司名稱'
  },
  'landing.contact.labels.volume': {
    'en': 'Estimated Volume',
    'zh-CN': '预计翻译量',
    'zh-TW': '預計翻譯量'
  },
  'landing.contact.labels.subject': {
    'en': 'Subject *',
    'zh-CN': '主题 *',
    'zh-TW': '主題 *'
  },
  'landing.contact.labels.message': {
    'en': 'Message',
    'zh-CN': '留言内容',
    'zh-TW': '留言內容'
  },
  'landing.contact.labels.send': {
    'en': 'Send Message',
    'zh-CN': '发送信息',
    'zh-TW': '發送信息'
  },
  'landing.contact.placeholders.name': {
    'en': 'Jane Doe',
    'zh-CN': '张三',
    'zh-TW': '張三'
  },
  'landing.contact.placeholders.email': {
    'en': 'jane@company.com',
    'zh-CN': 'zhangsan@company.com',
    'zh-TW': 'zhangsan@company.com'
  },
  'landing.contact.placeholders.subjectService': {
    'en': 'Inquiry about legal translation',
    'zh-CN': '关于法律文档翻译的咨询',
    'zh-TW': '關於法律文檔翻譯的諮詢'
  },
  'landing.contact.placeholders.subjectSupport': {
    'en': 'Issue with PDF upload',
    'zh-CN': 'PDF 上传遇到的问题',
    'zh-TW': 'PDF 上傳遇到的問題'
  },
  'landing.contact.placeholders.message': {
    'en': 'Tell us more about your needs...',
    'zh-CN': '请告诉我们您的具体需求...',
    'zh-TW': '請告訴我們您的具體需求...'
  },
  'landing.contact.options': {
    'en': 'Less than 100 pages/mo,100 - 1,000 pages/mo,1,000+ pages/mo,One-time project',
    'zh-CN': '少于 100 页/月,100 - 1,000 页/月,1,000+ 页/月,一次性项目',
    'zh-TW': '少於 100 頁/月,100 - 1,000 頁/月,1,000+ 頁/月,一次性項目'
  },
  'landing.footer.rights': {
    'en': 'RoundBlock. All rights reserved.',
    'zh-CN': 'RoundBlock. 保留所有权利。',
    'zh-TW': 'RoundBlock. 保留所有權利。'
  }
};

// 获取翻译的函数
export const getTranslation = (key: string, language: Language): string => {
  const translation = translations[key];
  if (!translation) {
    console.warn(`Translation key "${key}" not found for language "${language}"`);
    return key; // 如果找不到翻译，返回原键名
  }
  
  const translatedText = translation[language];
  return translatedText || key; // 如果特定语言的翻译不存在，返回原键名
};

// 格式化翻译（支持插值）
export const formatTranslation = (
  key: string, 
  language: Language, 
  params?: Record<string, string | number>
): string => {
  let translation = getTranslation(key, language);
  
  if (params) {
    Object.keys(params).forEach(paramKey => {
      const regex = new RegExp(`\\{${paramKey}\\}`, 'g');
      translation = translation.replace(regex, String(params[paramKey]));
    });
  }
  
  return translation;
};